var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "14", height: "14", viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Group 3"
    ),
    React.createElement(
      "g",
      { stroke: "#CBCEE0", strokeWidth: "1.5", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
      React.createElement("path", { d: "M10.745 4.364c0 1.81-1.497 3.276-3.343 3.276-1.847 0-3.343-1.466-3.343-3.276 0-1.809 1.496-3.276 3.343-3.276 1.846 0 3.343 1.467 3.343 3.276zM12.569 13H1.627c0-2.96 2.448-5.36 5.472-5.36 3.021 0 5.47 2.4 5.47 5.36z" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/ConnectedComponents/ConstituentCard/constituent_icon.svg